export const key = 'key';
export const label = 'label';
export const name = 'name';
export const value = 'value';
export function cleanProps(props) {
    Object.keys(props).forEach((key) => {
        if (!props[key]) {
            delete props[key];
        }
    });
    return props;
}
export function hasProp(obj, name) {
    return Object.prototype.hasOwnProperty.call(obj, name);
}
export function orderProp(pkg, order) {
    if (!pkg) {
        return;
    }
    if (!order) {
        order = Object.keys(pkg).sort();
    }
    const result = {};
    for (const prop of order) {
        if (prop in pkg) {
            result[prop] = pkg[prop];
        }
    }
    return Object.assign(result, pkg);
}
//# sourceMappingURL=props.js.map